<template>
  <div class="trip-review">
    <slot></slot>
    <b-tabs v-model="activeTab">
      <b-tab-item label="Itinerary review">
        <div class="flight-info">
          <div type="is-primary" class="breakdown bottom-30">
            <div class="pair">
              <span class="key">Adult airfare:</span>
              <span class="value-small">
                R{{ formattedPrice(Math.ceil(priceResponse.fareBreakdown.adults.baseFare)) }}
              </span>
            </div>
            <div class="pair" v-if="priceResponse.fareBreakdown.youngAdults">
              <span class="key">Young adult airfare:</span>
              <span class="value-small">
                R{{ formattedPrice(Math.ceil(priceResponse.fareBreakdown.youngAdults.baseFare)) }}
              </span>
            </div>
            <div class="pair" v-if="priceResponse.fareBreakdown.children">
              <span class="key">Child airfare:</span>
              <span class="value-small">
                R{{ formattedPrice(Math.ceil(priceResponse.fareBreakdown.children.baseFare)) }}
              </span>
            </div>
            <div class="pair" v-if="priceResponse.fareBreakdown.infants">
              <span class="key">Infant airfare:</span>
              <span class="value-small">
                R{{ formattedPrice(Math.ceil(priceResponse.fareBreakdown.infants.baseFare)) }}
              </span>
            </div>
            <div class="pair">
              <span class="key">Total airport taxes:</span>
              <span class="value-small">
                R{{ formattedPrice(Math.ceil(priceResponse.fareBreakdown.taxAmount)) }}
              </span>
            </div>
            <div class="pair" v-if="productsCost > 0">
              <span class="key">Total extras:</span>
              <span class="value-small"> R{{ formattedPrice(Math.ceil(productsCost)) }} </span>
            </div>
            <div class="pair" v-if="paymentCharge > 0">
              <span class="key">Payment option fee:</span>
              <span class="value-small"> R{{ formattedPrice(Math.ceil(paymentCharge)) }} </span>
            </div>
            <div class="pair" v-if="baggageCost > 0">
              <span class="key">Total baggage cost:</span>
              <span class="value-small"> R{{ formattedPrice(Math.ceil(baggageCost)) }} </span>
            </div>
            <div class="pair">
              <span class="totals">Total price:</span>
              <span class="totals"
                >R{{
                  formattedPrice(Math.ceil(
                    priceResponse.totalAmount +
                      productsCost +
                      (baggageCost > 0 ? baggageCost : 0) +
                      paymentCharge
                  ))
                }}</span
              >
            </div>
            <div class="key font-sm">
              (Includes online booking fee.)
            </div>
            <div v-if="addBaggage" style="font-size: 12px; opacity: 0.5">
              (Checked baggage now included)
            </div>
            <!-- <div v-if="priceResponse.priceIncrease" style="font-size: 12px; opacity: 0.5;">(Price adjusted R{{ Math.ceil(priceResponse.priceIncrease) }})</div> -->
          </div>
        </div>
        <hr class="content-break" />
        <div style="margin-bottom: 30px" v-for="flight in allFlights" :key="flight.index">
          <div class="pair">
            <span class="key">Flight:</span>
            <span class="value">
              {{ searchResults.airlineNames[flight.airlineCode] }}
              {{ flight.flightNumber }}
              <span class="dulled-text" v-if="flight.opAirlineCode">
                - operated by
                {{
                  searchResults.airlineNames[flight.opAirlineCode] ||
                    flight.opAirlineCode.toLowerCase()
                }}
              </span>
            </span>
          </div>
          <div class="pair">
            <span class="key">Depart:</span>
            <span class="value">
              {{ formatDate(flight.departureDateTime) }} ({{ flight.origCode }})
              {{ determineLocationFromCode(flight.origCode).airport }}
            </span>
          </div>
          <div class="pair">
            <span class="key">Arrive:</span>
            <span class="value">
              {{ formatDate(flight.arrivalDateTime) }} ({{ flight.destCode }})
              {{ determineLocationFromCode(flight.destCode).airport }}
            </span>
          </div>
          <div class="pair">
            <span class="key">Cabin:</span>
            <span class="value">
              {{
                flight.cabinClass.charAt(0).toUpperCase() +
                flight.cabinClass.toLowerCase().slice(1)
              }}
            </span>
          </div>
          <hr class="content-break">
        </div>
        <b-button class="button is-secondary" style="width: 100%" outlined @click="backToResults">
          Back to results
        </b-button>
      </b-tab-item>

      <b-tab-item label="Bags">
        <BaggageDisplay :allPassengers="allPassengers" />
        <b-button class="button is-secondary" style="width: 100%" outlined @click="backToResults">
          Back to results
        </b-button>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import FadeLoader from "vue-spinner/src/FadeLoader.vue";
import BaggageDisplay from '@/components/BaggageDisplay.vue';

export default {
  name: "tripReview",
  data: function () {
    return {
      fareBreakdownIsOpen: false,
      passengers: [],
      selectedBags: [],
      selectedProducts: [],
      activeTab: 0,
      priceCheckResult: undefined,
      priceCheckComplete: false,
    };
  },
  props: ["errors", "validationError", "allPassengers", "foo"],
  components: {
    FadeLoader,
    BaggageDisplay
  },
  computed: {
    ...mapState([
      "searchResults",
      "priceResponse",
      "selectedFlights",
      "products",
      "bags",
      "baggageCost",
      "currentBlock",
      "paymentCharge",
      "addBaggage",
      "additionalBaggageAllowed"
    ]),
    productsCost() {
      let result = 0;
      this.selectedProducts.forEach((selected) => {
        result += this.priceResponse.products.find((e) => e.id == selected).amount;
      });
      return result;
    },
    // searchParams() {
    //   return this.flags.isUrlSearch
    //     ? this.urlSearchParameters
    //     : this.searchParameters;
    // },
    allFlights() {
      let flights = [];
      for (let itinerary of this.priceResponse.itineraries) {
        for (let leg of itinerary.odoList) {
          for (let segment of leg.segments) {
            segment.specialAttributes = itinerary.specialServiceAttributes;
            flights.push(segment);
          }
        }
      }
      return flights;
    },
  },
  methods: {
    getSelectedBaggageDescription(passenger, origCode) {
      if (!passenger || !passenger.baggageSelection) {
        return '';
      }

      // Get all selected baggage IDs
      const selectedBaggageIds = passenger.baggageSelection
        .filter(selection => selection.selected)
        .map(selection => selection.id);

      // For each selected ID, find matching baggage in allBaggage
      const descriptions = selectedBaggageIds.map(id => {
          const matchingBaggage = this.priceResponse.baggageOptions.allBaggage.find(
            bag => {
              // If this is the first leg (origCode matches first flight orig)
              const isFirstLeg =
                origCode ===
                this.priceResponse.itineraries[0].odoList[0].segments[0]
                  .origCode;
              return (
                bag.id === id &&
                ((isFirstLeg && bag.direction === "OUTBOUND") ||
                  (!isFirstLeg && bag.direction === "INBOUND"))
              );
            }
          );
          // Split the description at 'for' and take the first part
          return matchingBaggage
            ? matchingBaggage.description.split(" for ")[0]
            : "";
        })
        .filter(desc => desc !== "");

      return descriptions.join(", ");
    },
    formattedPrice(n) {
      // also to 2 decimal places
      n = n.toFixed(2);
      var parts = n.toString().split(".");
      const numberPart = parts[0];
      const decimalPart = parts[1];
      const thousands = /\B(?=(\d{3})+(?!\d))/g;
      // Replace positions matched by the regular expression with a comma instead of space
      return numberPart.replace(thousands, ",") + (decimalPart ? "." + decimalPart : "");
    },
    backToResults() {
      this.$store.commit("updateBlock", 1);
      this.$router.go(-1);
    },
    isEmpty(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    determineLocationFromCode(code) {
      return this.searchResults.airportInfos.find((e) => {
        return e.iataCode == code;
      });
    },
    async setSelected() {
      this.priceResponse.baggageOptions.allBaggage.forEach((bag) => {
        this.selectedBags.push(bag.id);
      });
      if (this.priceResponse.products) {
        this.products.forEach((product) => {
          console.log(product);
          if (product.selectedValue) {
            this.selectedProducts.push(product.id);
          }
        });
      }
    },
    formatDate(date) {
      return moment(date).format("D MMMM YYYY [at] HH:mm");
    },
    updateProducts() {
      this.$store.commit("updateProducts", this.selectedProducts);
    },
  },
  mounted() {
    this.setSelected();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";
@import "@/assets/styles/variables.scss";

.rule-format {
  display: flex;
  flex-direction: column;
}

.passenger-count {
  margin-right: 5px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 6px;
  padding-right: 6px;
  color: black;
  border-radius: 4px;
  background-color: rgba(170, 166, 166, 0.881);
  display: flex;
  justify-content: center;
  align-items: center;
}

.pair {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.f-pair {
  display: flex;
  margin-bottom: 8px;
}

.key {
  text-align: left;
  opacity: 0.7;
}

.font-sm {
  font-size: 14px !important;
}

.f-key {
  text-align: left;
  opacity: 0.7;
  width: 120px;
}

.f-value {
  text-align: left;
  opacity: 1;
}

.value {
  text-align: left;
  opacity: 1;
  max-width: 70%;
  width: -webkit-fill-available;
}

.value-small {
  text-align: right;
  opacity: 1;
  max-width: 70%;
}

.totals {
  opacity: 1;
  font-weight: bold;
}

.review-content {
  border-radius: 4px;
  color: #4a4a4a;
  background: #f4f2f2;
  padding: 1.25em 1.5em;
  margin-bottom: 0.75em;
}

.width-100 {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.products-list {
  display: flex;
  flex-direction: column;
}

.product-description {
  font-size: 0.8em;
  margin-top: 0.5em;
}

.product-warning {
  padding: 0.75em;
  background-color: #ffe0e6 !important;
}

.margin-bot {
  margin-bottom: 1.2em;
}

.content-break {
  margin: 20px 0 40px 0 !important;
  background-color: $brandBlue !important;
  opacity: 0.1 !important;
  height: 1px;
}

.rule-heading {
  font-size: 1.1em;
  font-weight: bold;
  margin-right: 0.75em;
}

.heading-format {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.price-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.option-header {
  font-weight: bold;
  font-size: 1.1em;
}

.trip-review {
  align-self: flex-start;
  
  max-width: -webkit-fill-available;
  padding: 32px;
  width: 100%;
  background: #FFFFFF;
  border-top: 4px solid $brandOranges;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
}

.trip-review div.b-tabs {
  font-family: "Inter";
  font-size: 14px;
}

.air-rules {
  img {
    max-width: 100px;
    margin-right: 0.75em;
  }
  display: flex;
  flex-direction: column;
}

.rules-loader-wrapper {
  width: 100%;
  height: 100%;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.flight-info {
  display: flex;
  flex-direction: column;
}

.return-baggage {
  margin-top: 0.5em;
}

.message-body {
  padding: 1em;
}

.loading-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

.prompt-header {
  font-size: 1.5em;
  margin-top: 1rem;
  padding: 1rem;
}

.prompt-loader {
  margin-top: 3rem;
}

.dulled-text {
  font-size: 0.8em;
  font-style: italic;
}

.inline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 1em;
}

.no-margin-bottom {
  margin-bottom: 0 !important;
}

.progress-buttons {
  display: flex;
  width: 100%;
  position: sticky;
  bottom: 0;
  left: 0;
  padding: 0.75em;
  background: white;
  justify-content: flex-end;
  align-items: center;
}

.margin-left-auto {
  margin-top: 0.35em;
}

.margin-right {
  margin-right: 0.5em;
  color: white;
}

.button.is-secondary {
  background-color: #fff !important;
  color: #30384A !important;
  border: 2px solid #30384A !important;
  border-radius: 104px;
}

@media (max-width: 781px) {
  .trip-review {
    border-top: none;
  }
}
</style>

<style lang="scss">
@import "@/assets/styles/settings.scss";
@import "@/assets/styles/variables.scss";

.tabs {
  ul {
    justify-content: flex-start;
    flex-wrap: wrap;
    max-width: 100%;
    li {
      a:hover {
        border-bottom-color: $brandBlue;
      }
      a {
        justify-content: flex-start;
        padding-bottom: 30px;
        span {
          font-family: Helvetica Neue;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 150%;
          color: $brandBlue;
        }
      }
    }
  }
}

.tabs li.is-active a {
  border-bottom-color: $brandBlue;
}

@media (min-width: 781px) {
  .tabs {
    ul {
      justify-content: space-between;
      flex-wrap: nowrap;
      li {
        width: 50%;
      }
    }
  }
}

.modal-close::before,
.delete::before,
.modal-close::after,
.delete::after {
  background-color: black;
}

.message-header + .message-body {
  padding-top: 0 !important;
}

.message-header {
  p {
    color: white;
  }
}

.mango-and-radixx {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.rule {
  padding: 0 0 1em 0;
}

.modal .animation-content {
  display: flex;
  max-height: 90%;
}

.my-button {
  font-size: 0.8em !important;
}

@media (min-width: 781px) {
  .my-button {
    font-size: 1rem !important;
  }
}
</style>
